import * as React from "react";
import PropTypes from 'prop-types';

const SvgInstagramLine = props => {
  if (props.id !== "_svginstagramline") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="-2 -2 36 36" {...props}><path d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm0 30.154c7.804 0 14.154-6.35 14.154-14.154S23.804 1.846 16 1.846 1.846 8.196 1.846 16 8.196 30.154 16 30.154zm-.003-20.708c2.136 0 2.389.008 3.232.047.78.035 1.203.166 1.485.275.373.145.64.318.92.598.28.28.453.547.598.92.11.282.24.705.275 1.485.039.843.047 1.096.047 3.232 0 2.135-.008 2.388-.047 3.231-.035.78-.166 1.203-.275 1.485-.145.374-.318.64-.598.92a2.48 2.48 0 01-.92.598c-.282.11-.705.24-1.485.275-.843.039-1.096.047-3.232.047-2.135 0-2.388-.008-3.231-.047-.78-.035-1.203-.165-1.485-.275a2.478 2.478 0 01-.92-.598 2.478 2.478 0 01-.598-.92c-.11-.282-.24-.705-.275-1.485-.039-.843-.047-1.096-.047-3.231 0-2.136.008-2.389.047-3.232.035-.78.165-1.203.275-1.485a2.48 2.48 0 01.598-.92c.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.275.843-.039 1.096-.047 3.231-.047zm0 2.45a4.107 4.107 0 100 8.213 4.107 4.107 0 000-8.213zm5.23-.163a.96.96 0 10-1.92 0 .96.96 0 001.92 0zm-5.23 6.935a2.666 2.666 0 110-5.331 2.666 2.666 0 010 5.331z" /></svg>;
};

SvgInstagramLine.displayName = "_svginstagramline";
SvgInstagramLine.propTypes = {
  id: PropTypes.string
};
SvgInstagramLine.defaultProps = {
  id: ''
};
export default SvgInstagramLine;